import { render, staticRenderFns } from "./InputError.vue?vue&type=template&id=01d59484&scoped=true"
import script from "./InputError.vue?vue&type=script&lang=js"
export * from "./InputError.vue?vue&type=script&lang=js"
import style0 from "./InputError.vue?vue&type=style&index=0&id=01d59484&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d59484",
  null
  
)

export default component.exports